<template>
	<v-container grid-list-xl fluid>
		<v-layout row wrap>
			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('farm.farmOwner') }}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{ $t('farm.farmOwner') }}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.userAssoc.id ? farm.userAssoc.firstName + " " + farm.userAssoc.lastName : 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>

			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('farm.govRegistrationNo') }}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{ $t('farm.govRegistrationNo') }}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.govRegistrationNum || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>



			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('farm.ownershipType') }}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{ $t('farm.ownershipTypeState') }}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.farmOwnershipType || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<!-- <v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.contractMating')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
										<v-icon v-bind="attrs" v-on="on">
											mdi-help-circle-outline
										</v-icon>
										</template>
										<span>{{$t('farm.contractMatingState')}}
										</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.contractMating || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
      		</v-flex> -->
			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5">
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('farm.productionSystem') }}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{ $t('farm.productionSystemState') }}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									<!-- {{ farm.productionSystemAssoc?.name || "N/A" }} -->
									{{ (productionSystem.length > 0 && productionSystem.map(item =>
										item.name).join(' , ')) || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
<!-- 
			<v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5" v-if="farm.farmOwnershipType === 'corporate'">
				<v-card class="green2" flat min-height="100">
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('cooperativeId') }}
									<v-tooltip left color="black" max-width="350">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>Cooperative ID refers to a unique identifier or code assigned to a cooperative
											or union.</span>

									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.cooperativeId || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex> -->


			<!-- <v-flex xs6 sm4 md2 xl2 :style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5" v-if="farm.farmOwnershipType === 'corporate'">
				<v-card class="green2" flat min-height="100">
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{ $t('farm.cooperativeName') }}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{ $t('farm.cooperativeName') }}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.cooperativeName || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex> -->


		</v-layout>
	</v-container>
</template>
<script>
// import { mapGetters } from "vuex";
import FarmService from "@/_services/farmService";
import {
	getFarmFormOptions
} from "@/graphql/Farm.gql";

export default {
	apollo: {
		getFarmFormOptions: {
			query: getFarmFormOptions,
			update: (data) => data.getFarmFormOptions,
			fetchPolicy: "no-cache",
			variables() {
				return {};
			},
			result({ data }) {
				const farmownershipType = data.getFarmFormOptions.find(
					(owner) => owner.groupName == "farm-ownership-type"
				);
				this.farmownershipType = farmownershipType.options;
				const farmType = data.getFarmFormOptions.find(
					(farmType) => farmType.groupName == "farm-type"
				);
				this.farmType = farmType.options;
				const productionSystem = data.getFarmFormOptions.find(
					(farmType) => farmType.groupName == "production-system"
				);
				this.farmProductionSystem = productionSystem.options;
				this.loading = false;
				console.log("AVAILABLE QUICK FILTER", data);
			},
		},
	},
	name: "Information",
	data() {
		return {
			farmProductionSystems: [],
			farmProductionSystem: [],
			productionSystem: [],
		}
	},
	computed: {
		// ...mapGetters(["getfarm"]),
	},
	props: {
		farm: {
			require: true
		}
	},
	async mounted() {
		console.log('prod system', this.productionSystem)
		await this.getFarmFormOptions();
		const options = await FarmService.getFarmOptions();
		this.farmProductionSystems = [...options.FarmProductionSystem, ...this.farmProductionSystem];
		let productionSystem = typeof JSON.parse(this.$props.farm.productionSystem) === 'object' ?
			JSON.parse(this.$props.farm.productionSystem) : [JSON.parse(this.$props.farm.productionSystem)]
		console.log(productionSystem)
		this.productionSystem = this.farmProductionSystems.filter(item => productionSystem.some(i => i === item.id));
	},
	methods: {
		async getFarmFormOptions() {
			const response = await this.$apollo.query({
				query: getFarmFormOptions,
				fetchPolicy: "no-cache",
			});
			console.log('resp', response)
			const productionSystem = response?.data?.getFarmFormOptions.find(
				(farmType) => farmType.groupName == "FarmProductionSystem"
			);
			this.farmProductionSystem = productionSystem.options;

		}
	},
};
</script>
<style lang="scss" scoped>
.flex.lg5-custom {
	width: 20%;
	max-width: 80%;
	flex-basis: 20%;
}
</style>